import React, { Component } from 'react';
const products = [{
  name: 'EDMMax FC45HW (Horizontal, Submerged) Fast Wire EDM',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/14b4cf061a6b41417cf31086391300eb/large-0001841_edmmax-fc45-horizontal-submerged-fast-wire-edm.jpg',
  href: '/listings/4738616-edmmax-fc45hw-horizontal-submerged-fast-wire-edm'
}, {
  name: 'EDMMax FC65HW (Horizontal, Submerged) Fast Wire EDM',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/8b5b962f766bc98b418ea38966e1fe29/large-edm-max-fc-64-horizontal-submerged-fast-wire-edm.jpg',
  href: '/listings/4738617-edmmax-fc65hw-horizontal-submerged-fast-wire-edm'
}, {
  name: 'EDMMax 1100HW (Horizontal, Submerged) Fast Wire EDM',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/7b74c252a05e0a01faa4dfb7bd0b1db7/large-0001822_edmmax-1100hw-horizontal-submerged-fast-wire-edm.jpg',
  href: '/listings/4738618-edmmax-1100hw-horizontal-submerged-fast-wire-edm'
}];
export function HorizontalProductsSection() {
  return <section className="bg-white p-6 md:p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0" data-id="element-1864">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-1865">
        {products.map((product, pIndex) => <div key={pIndex} className="group bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col h-full" data-id="element-1866">
            <a href="/m7_view_item.html" className="bg-gray-50 p-6 h-56 flex items-center justify-center border-b border-gray-100 block" data-id="element-1867">
              <img src={product.image} alt={product.name} className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-500 block" data-id="element-1868" />
            </a>
            <div className="p-5 flex flex-col flex-grow" data-id="element-1869">
              <a href="/m7_view_item.html" className="no-underline" data-id="element-1870">
                <h3 className="text-base font-bold text-navy mb-4 leading-tight group-hover:text-orange transition-colors" data-id="element-1871">
                  {product.name}
                </h3>
              </a>
              <div className="mt-auto pt-4 border-t border-gray-100 flex flex-col space-y-2" data-id="element-1872">
                <a href={`/ContactPeakMachineSales.html?i515589:default[Product%20Title]=${encodeURIComponent(product.name)}`} className="inline-flex items-center justify-center w-full bg-navy text-white px-4 py-2 rounded-md font-bold text-sm hover:bg-orange transition-colors no-underline" data-id="element-1873">
                  Request for Quote
                </a>
                <a href="/m7_view_item.html" className="inline-flex items-center justify-center w-full bg-gray-100 text-navy px-4 py-2 rounded-md font-bold text-sm hover:bg-gray-200 transition-colors no-underline" data-id="element-1874">
                  More Information
                </a>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}